export const noExamReasons = [
  { title: "Exam already completed", value: "Exam already completed" },
  { title: "Have examiner contact me", value: "Have examiner contact me" },
  { title: "Other", value: "Other" },
];
